import AWS from "aws-sdk";

AWS.config.update({
  accessKeyId: "AKIA4ZR3ZHVLLCBOIK5P",
  secretAccessKey: "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",
});

const generateRandomName = (length) => {
  const alphanumericChars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let name = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * alphanumericChars.length);
    name += alphanumericChars.charAt(randomIndex);
  }
  return name;
};

const myBucket = new AWS.S3({
  params: { Bucket: "lionfortcrm" },
  region: "ap-south-1",
});

// this method will upload file to s3 and update the data in DB
async function uploadFile(file, folderName) {
  if (!file) return;

  const fileExtension = file.name.split(".").pop();

  const relativePath = `${folderName}/` + generateRandomName(8) + "." + fileExtension;

  const path = "https://d30yzz1jc6jp1l.cloudfront.net/" + relativePath;

  const params = {
    // ACL: "public-read",
    Body: file,
    Bucket: "lionfortcrm",
    Key: relativePath,
  };

  // this will upload the file to the s3
  await myBucket
    .putObject(params)
    .on("httpUploadProgress", (evt) => {
      // alert("image uploaded successfully")
      console.log("uploaded Image");
    })
    .promise()
    .then(() => console.log("Success"))
    .catch((err) => console.log("Error: ", err));
  //    .send((err) => {
  // 	if (err) console.log(err);
  // 	alert("error while uploading image")
  // 	// throw new Error("error while uploading image   : \n ", err)
  //     return;
  // });

  //? here I have path image where it was stored in S3 onsubmit

  return path;

  // It should return the path which was added to the path
}
export { uploadFile };
